import React from 'react';
import {Link} from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import pageConstruction from '../../assests/images/construction.png';

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
              <div className="surface-ground flex align-items-center justify-content-center overflow-hidden">
                  <div
                      className="flex flex-column align-items-center justify-content-center w-full h-full"
                      style={{ backgroundColor: '#f4f4f4' }}
                  >
                      <div
                          style={{
                              borderRadius: '56px',
                              padding: '2rem',
                              // background: 'linear-gradient(180deg, rgba(33, 150, 243, 0.2) 10%, rgba(33, 150, 243, 0) 30%)',
                              textAlign: 'center',
                          }}
                      >
                          {/* <span className="text-blue-500 font-bold text-3xl">404</span>
                          <h1 className="text-900 font-bold text-5xl mb-3">Not Found</h1>
                          <div className="text-600 mb-5">Requested resource is not available</div> */}
                          <div style={{ marginBottom: '20px' }}><img src={pageConstruction} /></div>
                          <button
                              className="p-button p-component"
                              style={{
                                  backgroundColor: '#2196f3',
                                  color: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '0.5rem 1rem',
                                  border: 'none',
                              }}
                              onClick={() =>navigate("/")}
                          >
                              Go to Home
                          </button>
                      </div>
                  </div>
              </div>
  );
    };
  export default PageNotFound;